import { Select } from "antd";
import { type FC, useMemo } from "react";

interface SubmissionTypeSelectProps {
	isLoading: boolean;
	selectedSubmissionType: string;
	onSubmissionTypeChange: (type: string) => void;
	organizationId?: number;
}

/**
 * First dropdown: Choose between main form types and Property Condition Assessment
 * - Org 28: Handyman Checklist (form_id 2), QC Checklist (form_id 4), Property Condition Assessment (form_id 7)
 * - Other orgs: Asset Tagging (form_id 3), Property Condition Assessment (form_id 7)
 */
const SubmissionTypeSelect: FC<SubmissionTypeSelectProps> = ({
	isLoading,
	selectedSubmissionType,
	onSubmissionTypeChange,
	organizationId,
}) => {
	const isOrg28 = organizationId === 28;

	const options = useMemo(() => {
		if (isOrg28) {
			return [
				{ value: "2", label: "Handyman Checklist" },
				{ value: "4", label: "QC Checklist" },
				{ value: "7", label: "Property Condition Assessment" },
			];
		}
		return [
			{ value: "3", label: "Asset Tagging" },
			{ value: "7", label: "Property Condition Assessment" },
		];
	}, [isOrg28]);

	const handleChange = (value: string) => {
		onSubmissionTypeChange(value);
	};

	return (
		<Select
			style={{ width: 220 }}
			onChange={handleChange}
			value={selectedSubmissionType || options[0]?.value}
			options={options}
			placeholder={isLoading ? "Loading..." : "Select submission type"}
			disabled={isLoading}
		/>
	);
};

export { SubmissionTypeSelect };
